import moment from 'moment-timezone'

export const DEFAULT_TIME_ZONE = 'UTC'

export const dueDate = (date: Date | string | number, timeZone: string): Date =>
  moment.utc(date).tz(timeZone).endOf('day').toDate()
